const basePath = '/pengelolaan-kinerja'

export const PENGELOLAAN_KINERJA_BASE_PATH = basePath

// Beranda
export const PENGELOLAAN_KINERJA_BERANDA_PATH = PENGELOLAAN_KINERJA_BASE_PATH

// Guru
export const PENGELOLAAN_KINERJA_GURU_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/guru`

// Kepala Sekolah
export const PENGELOLAAN_KINERJA_KS_PENILAI_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/kepala-sekolah/penilai`
export const PENGELOLAAN_KINERJA_KS_PEGAWAI_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/kepala-sekolah/pegawai`
export const PENGELOLAAN_KINERJA_KS_TIM_KINERJA_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/kepala-sekolah/tim-kinerja`

// Pamong
export const PENGELOLAAN_KINERJA_PAMONG_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/pamong`
export const PENGELOLAAN_KINERJA_PAMONG_PEGAWAI_PATH = `${PENGELOLAAN_KINERJA_PAMONG_PATH}/pegawai`
export const PENGELOLAAN_KINERJA_PAMONG_PEJABAT_PENILAI_KINERJA_PATH = `${PENGELOLAAN_KINERJA_PAMONG_PATH}/pejabat-penilai-kinerja`
export const PENGELOLAAN_KINERJA_PAMONG_DINAS_PATH = `${PENGELOLAAN_KINERJA_PAMONG_PATH}/dinas`

// Kepala Sekolah SPNF
export const PENGELOLAAN_KINERJA_KSPNF_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/kepala-spnf`
export const PENGELOLAAN_KINERJA_KSPNF_PEGAWAI_PATH = `${PENGELOLAAN_KINERJA_KSPNF_PATH}/pegawai`
export const PENGELOLAAN_KINERJA_KSPNF_PENILAI_PATH = `${PENGELOLAAN_KINERJA_KSPNF_PATH}/penilai`

// Kepala SKB
export const PENGELOLAAN_KINERJA_KEPALA_SKB_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/kepala-skb`
export const PENGELOLAAN_KINERJA_KEPALA_SKB_PEGAWAI_PATH = `${PENGELOLAAN_KINERJA_KEPALA_SKB_PATH}/pegawai`
export const PENGELOLAAN_KINERJA_KEPALA_SKB_TIM_KINERJA_PATH = `${PENGELOLAAN_KINERJA_KEPALA_SKB_PATH}/tim-kinerja`
export const PENGELOLAAN_KINERJA_KEPALA_SKB_PENILAI_PATH = `${PENGELOLAAN_KINERJA_PAMONG_PATH}/pejabat-penilai-kinerja`
export const PENGELOLAAN_KINERJA_KEPALA_SKB_DINAS_PATH = `${PENGELOLAAN_KINERJA_KEPALA_SKB_PATH}/dinas`

// Pengawas Sekolah
export const PENGELOLAAN_KINERJA_PS_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/pengawas-sekolah`
export const PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH = `${PENGELOLAAN_KINERJA_PS_PATH}/pegawai`
export const PENGELOLAAN_KINERJA_TIM_KINERJA_PS_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/tim-kinerja`
export const PENGELOLAAN_KINERJA_PEJABAT_PENILAI_KINERJA_PS_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/pejabat-penilai-kinerja`

// GPK
export const PENGELOLAAN_KINERJA_GPK_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/gpk`
export const PENGELOLAAN_KINERJA_GPK_PEGAWAI_PATH = `${PENGELOLAAN_KINERJA_GPK_PATH}/pegawai`
export const PENGELOLAAN_KINERJA_GPK_TIM_KINERJA_PATH = `${PENGELOLAAN_KINERJA_GPK_PATH}/tim-kinerja`
export const PENGELOLAAN_KINERJA_GPK_PEJABAT_PENILAI_KINERJA_PATH = `${PENGELOLAAN_KINERJA_GPK_PATH}/pejabat-penilai-kinerja`

// Penilik SPNF
export const PENGELOLAAN_KINERJA_PENILIK_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/penilik`
export const PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH = `${PENGELOLAAN_KINERJA_PENILIK_PATH}/pegawai`
export const PENGELOLAAN_KINERJA_TK_PENILIK_PATH = `${PENGELOLAAN_KINERJA_PENILIK_PATH}/tim-kinerja`
export const PENGELOLAAN_KINERJA_PPK_PENILIK_PATH = `${PENGELOLAAN_KINERJA_PENILIK_PATH}/pejabat-penilai-kinerja`

// Dinas Pendidikan
export const PENGELOLAAN_KINERJA_KADIN_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/kepala-dinas`
export const PENGELOLAAN_KINERJA_KADIN_PEMBERI_PREDIKAT_PATH = `${PENGELOLAAN_KINERJA_KADIN_PATH}/pemberi-predikat-kinerja-organisasi`
export const PENGELOLAAN_KINERJA_KADIN_ASN_SWASTA_PATH = `${PENGELOLAAN_KINERJA_KADIN_PATH}/asn-swasta/`

// Notifikasi
export const PENGELOLAAN_KINERJA_NOTIFIKASI_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/notifikasi`

// Riwayat
export const PENGELOLAAN_KINERJA_RIWAYAT_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/riwayat`
export const PENGELOLAAN_KINERJA_RIWAYAT_KS_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/riwayat/[riwayatId]`
export const PENGELOLAAN_KINERJA_RIWAYAT_KS_V2_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/riwayat/ks/[riwayatId]`
export const PENGELOLAAN_KINERJA_RIWAYAT_GURU_PATH = `${PENGELOLAAN_KINERJA_RIWAYAT_PATH}/guru`

// ASN in Swasta
export const PENGELOLAAN_KINERJA_ASN_SWASTA_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/asn-swasta`
export const PENGELOLAAN_KINERJA_ASN_SWASTA_PPK_PATH = `${PENGELOLAAN_KINERJA_ASN_SWASTA_PATH}/pejabat-penilai-kinerja`

// Errors
export const PENGELOLAAN_KINERJA_NOT_FOUND_PATH = `${PENGELOLAAN_KINERJA_BASE_PATH}/404`
